import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

/**
 * Asks the gateway to email the signed-in user a single-use link to set a new
 * password. The gateway gets the link from Auth0 and sends it from our own
 * mail service; it answers 400 for SSO users, who have no Auth0 password.
 */
export function useSendPasswordResetEmail(onSuccess?: () => void) {
  const url = `/v2/orm/user/passwordReset`;

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<null, null>(request, {
    onSuccess,
  });
}

export default useSendPasswordResetEmail;
